<template>
  <div class="role" v-show="this.$root.myData.star_name">
    <div class="animated fadeIn">
      <img class="cosleep-icon" src="../assets/icon-image.png"/>

      <div class="top-template">
        <img class="title" src="../assets/title-image.png"/>
        <div class="cd">
          <Music mid="2" need="true" class="music" ref="music"/>
          <img class="cd-bar" :class="{'rotate-30': this.$store.state.musicPlay}" src="../assets/cd-bar-image.png"/>
          <div class="cd-avatar-parent">
            <img class="cd-avatar" :class="{'roatate-animation': !listenDone}" :style="{'animation-play-state': this.$store.state.musicPlay ? 'running' : 'paused'}" :src="this.$root.myData.star_avatar"/>
          </div>
          <waveAnimation width="230px" height="230px" :play="this.$store.state.musicPlay" class="wave"/>
          <img class="cd-image" :class="{'roatate-animation': !listenDone}" :style="{'animation-play-state': this.$store.state.musicPlay ? 'running' : 'paused'}" src="../assets/cd-image.png">
        </div>
      </div>

      <div class="handmould-template">
        <img class="bg" src="../assets/handmould.png"/>
        <div class="decoration-template">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
        <div class="text">
          “{{this.$root.myData.star_subtitle}}”
        </div>
        <!-- <span style="color:red;position: fixed;right:0px;top:0px;">{{this.$store.state.musicPlay}}</span> -->
        <div class="asign">
          ——哄睡师·{{this.$root.myData.star_name}}
        </div>
      </div>

      <div class="bottom-template">
        <Button text="更多哄睡师" @click.native="toListPage()" style="margin-right: 10px"></Button>
        <Button @click.native="toDownLoad()" text="下载小睡眠APP"></Button>
      </div>

      <div class="done-template" @click.self="listenDone = false" v-if="listenDone">
        <div class="done">
          <img class="close" @click.self="listenDone = false" src="../assets/close.png" />
          <img @click.self="listenDone = false" class="done-img remove-unclick" src="../assets/img_album_stop@2x.png"/>
          <Button @click.native="toDownLoad()"  text="下载小睡眠"></Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../components/Button'
import Music from '../components/music.vue'
import waveAnimation from '../components/waveAnimation'

export default {
  name: 'Role',
  data () {
    return {
      listenDone: false
    }
  },
  components: {
    Music,
    Button,
    waveAnimation
  },
  methods: {
    toListPage () {
      this.$router.push('/list')
    },
    toDownLoad () {
      window.location.href = this.$root.downloadLink
    }
  },
  mounted () {
    this.$root.showBg = false
  }
}
</script>

<style lang="scss" scoped>
  .music {
    opacity: 0;
    position: absolute;
    top: 0px;
    width: 330px;
    height: 240px;
    left: 0px;
    z-index: 3;
  }
  .role {
    background-image: url("../assets/bg_light@3x.png");
    background-size: 110% auto;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    justify-content: center;
    .cosleep-icon {
      margin-top: 0px;
      position: relative;
      top:10px;
      width: 90px;
    }

    .top-template {
      height: 400px;
      .title {
        position: relative;
        z-index: 1;
        width: 341px;
      }

      .cd {
        position: relative;
        top: -70px;
        .cd-bar {
          z-index: 2;
          transition: 0.4s linear;
          transform-origin: 8% 8%;
          position: absolute;
          right: -30px;
          top: -40px;
          height: 162px;
        }
        .cd-image {
          position: relative;
          top: 2px;
          width: 258px;
        }
        .wave {
          position: absolute;
          top: 50%;
          left:50%;
          transform: translateY(-50%) translateX(-50%);
        }
        .cd-avatar-parent {
          z-index: 2;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateY(-50%) translateX(-50%);
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .cd-avatar {
          width: 120px;
          border-radius: 50%;
        }
      }
    }

    .handmould-template {
      position: relative;
      top: -10px;
      width: 345px;
      height: 180px;
      .bg {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 345px;
      }

      .decoration-template {
        position: absolute;
        top: 55px;
        left: 32px;
        z-index: 2;
        .line {
          margin-top: 25px;
          border-bottom: 1px solid rgba(151, 151, 151, 0.2);
          width: 279px;
        }
      }

      .text {
        font-size: 14px;
        position: absolute;
        top: 59px;
        left: 36px;
        color: rgba(0, 0, 0, 0.5);
        font-weight: 600;
        text-align: left;
        line-height: 26px;
        width: 276px;
      }

      .asign {
        text-align: right;
        position: absolute;
        top: 110px;
        right: 40px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.5);
      }
    }

    .bottom-template {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 340px;
      margin-bottom: 10px;
    }
  }
</style>
